/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Заявка
 */
export interface Order {
  /**
   * ИД сервиса
   * @format int64
   */
  caseId?: number;

  /** Вид заявки */
  type?: string;

  /** Наименование клиента короткое */
  clientName?: string;

  /** ИНН клиента */
  clientInn?: string;

  /** Имя контакта */
  contactName?: string;

  /** Электронная почта контакта */
  contactMail?: string;

  /**
   * Телефон контакта
   * @pattern \+\d{11}
   */
  contactPhone?: string;

  /**
   * ИД платежки на предоплату
   * @format uuid
   */
  paymentId?: string;
}

export type EmptyResponse = object;

export interface ErrorMessage {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Сервис
 */
export interface Case {
  /**
   * Уникальный идентификатор
   * @format int64
   * @example 1
   */
  id?: number;

  /**
   * Наименование сервиса
   * @example Платёжные поручения
   */
  name: string;

  /**
   * Описание сервиса
   * @example Сервис для получения платежных поручений
   */
  description?: string;

  /** Ссылка на ресурс */
  link: string;

  /**
   * Порядок внутри сервиса
   * @format int32
   * @example 3
   */
  order: number;

  /**
   * Идентификатор блока, в котором должен находится сервис
   * @format int64
   * @example 1
   */
  caseBlockId?: number;

  /**
   * Признак использования внешнего сервиса
   * @example true
   */
  external?: boolean;

  /** Содержимое файла картинки в Base64 */
  picture?: string;

  /** Признак, что требуется отправка на эл.почту */
  toSend?: boolean;

  /** Получатель */
  recipient?: string;

  /** Отправитель */
  senderEmail?: string;

  /** Архивировать вложение */
  isArchive?: boolean;

  /** Архивировать с паролем */
  hasPass?: boolean;

  /** Пароль */
  password?: string;

  /**
   * Дата начала действия пароля
   * @format date
   */
  passFromDate?: string;

  /** Признак отображения сервиса в МП */
  availableMobile?: boolean;

  /** Диплинк для МП */
  mobileLink?: string;

  /** Тип партнерского сервис */
  partnerProductType?: string;
}

/**
 * Блок сервисов
 */
export interface CaseBlock {
  /**
   * Уникальный идентификатор
   * @format int64
   * @example 1
   */
  id?: number;

  /**
   * Имя блока
   * @example Управление бизнесом
   */
  blockName: string;

  /**
   * Порядок отображения среди других блоков
   * @format int32
   * @example 1
   */
  displayOrder: number;

  /** Список сервисов */
  cases: Case[];
}

/**
 * Сервис
 */
export interface CaseResponse {
  /**
   * Уникальный идентификатор
   * @format int64
   * @example 1
   */
  id: number;

  /** Тип партнерского сервис */
  partnerProductType?: "ORDER" | "PREPAY";

  /**
   * Наименование сервиса
   * @example Платёжные поручения
   */
  name: string;

  /**
   * Подробное описание продукта или услуги
   * @example Сервис для получения платежных поручений
   */
  prodDescription?: string;

  /** Цена за подключения */
  price?: number;

  /** Валюта цены */
  currCode?: string;

  /** Наименование партнера */
  partnerName?: string;

  /** ИНН партнера */
  partnerInn?: string;

  /** КПП партнера */
  partnerKpp?: string;

  /** БИК банка для перевода оплаты за подключение */
  bic?: string;

  /** Корр. счет */
  corrAccount?: string;

  /** Расчетный счет партнера в банке получателя */
  account?: string;

  /** Наименование банка получателя */
  bankName?: string;

  /** Назначение платежа */
  ground?: string;

  /** Значение  НДС */
  vat?: number;

  /** Ссылка на политику обработки персональных данных */
  persLink?: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис owb-ms-prd-showcase
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-showcase.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ <info@rshbintech.ru> (https://rshbintech.ru/)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Заявки
     * @name CreateOrder
     * @summary Создание заявки
     * @request POST:/api/showcase/v1/external/order
     * @secure
     */
    createOrder: (data: Order, params: RequestParams = {}) =>
      this.request<EmptyResponse, ErrorMessage>({
        path: `/api/showcase/v1/external/order`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сервисы и блоки сервисов
     * @name GetCaseBlocks
     * @summary Получение информации о доступных блоках сервисов
     * @request GET:/api/showcase/v1/external/case
     * @secure
     */
    getCaseBlocks: (params: RequestParams = {}) =>
      this.request<CaseBlock[], ErrorMessage>({
        path: `/api/showcase/v1/external/case`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сервисы и блоки сервисов
     * @name GetCase
     * @summary Получение информации о сервисе
     * @request GET:/api/showcase/v1/external/case/{id}
     * @secure
     */
    getCase: (id: number, params: RequestParams = {}) =>
      this.request<CaseResponse, ErrorMessage>({
        path: `/api/showcase/v1/external/case/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сервисы и блоки сервисов
     * @name GetPicture
     * @summary Получение картинки для сервиса
     * @request GET:/api/showcase/v1/external/case/{id}/picture
     * @secure
     */
    getPicture: (id: number, params: RequestParams = {}) =>
      this.request<File, ErrorMessage>({
        path: `/api/showcase/v1/external/case/${id}/picture`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
}

export const api = new Api();
